import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 246027 283961"
    {...props}
  >
    <path
      d="M152575 90872 123122 0 93536 90826 109 70894l63870 71040L0 212870l93456-19785 29445 90876 29590-90830 93423 19936-63862-71041 63975-70944z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
